import React from 'react'
import { Props } from './types'

export const Check: React.FC<Props> = (props) => {
  return (
    <svg
      version="1.1"
      x="0px"
      y="0px"
      width="16px"
      height="16px"
      viewBox="0 0 16 16"
      {...props}
    >
      <polygon points="6.9 15.75 .96 8.97 2.46 7.66 6.68 12.46 13.55 2.05 15.22 3.15 6.9 15.75" />
    </svg>
  )
}
